import { DashRegistrationStep } from '@/types/dashboard';

export interface IScreeningProgressModel {
    id: number;
    editKey: string;
    centerId: number | null;
    isIE: boolean;
    currentRegistrationStep: DashRegistrationStep;
    isLiver: boolean;
    isFemale: boolean;
    hasMicrositeRecipient: boolean;
    isQuickStartComplete: boolean;
    isAcceptTransfusionsComplete: boolean;
    isAssessLiverHealthComplete: boolean;
    isAssessNutcrackerComplete: boolean;
    isAssessOrganDiseaseComplete: boolean;
    isAssessHeartAttackComplete: boolean;
    isAssessDiabetesComplete: boolean;
    isAssessCancerComplete: boolean;
    isAssessKidneyStonesComplete: boolean;
    isPregnantOrNursingComplete: boolean;
    isAssessTobaccoComplete: boolean;
    isAssessHivComplete: boolean;
    isDonationDetailsComplete: boolean;
    isDonationDetailsMicrositeComplete: boolean;
    isVoucherChoiceComplete: boolean;
    isScreeningSummaryComplete: boolean;
    isScreeningComplete: boolean;

    languageData: Record<string, string>;
}

export const defaultScreeningProgress: IScreeningProgressModel = {
    id: 0,
    editKey: '',
    centerId: null,
    isIE: false,
    currentRegistrationStep: DashRegistrationStep.GetStarted,
    isLiver: false,
    isFemale: false,
    hasMicrositeRecipient: false,
    isQuickStartComplete: false,
    isAcceptTransfusionsComplete: false,
    isAssessLiverHealthComplete: false,
    isAssessNutcrackerComplete: false,
    isAssessOrganDiseaseComplete: false,
    isAssessHeartAttackComplete: false,
    isAssessDiabetesComplete: false,
    isAssessCancerComplete: false,
    isAssessKidneyStonesComplete: false,
    isPregnantOrNursingComplete: false,
    isAssessTobaccoComplete: false,
    isAssessHivComplete: false,
    isDonationDetailsComplete: false,
    isDonationDetailsMicrositeComplete: false,
    isVoucherChoiceComplete: false,
    isScreeningSummaryComplete: false,
    isScreeningComplete: false,
    languageData: {},
};
